const accountCategories = [
  { account: '141-01-1001', category: 'ROW Lease Fees' },
  { account: '141-01-1003', category: 'ROW Agent Fees' },
  { account: '141-01-1004', category: 'Preliminary Survey' },
  { account: '141-01-1007', category: 'Misc Permits and Fees' },

  { account: '141-01-2001', category: 'Line Pipe' },
  { account: '141-01-2002', category: 'Segmentable Elbows' },
  { account: '141-01-2023', category: 'Flow/Pressure Control' },
  { account: '141-01-2041', category: 'Pipeline Markers' },
  { account: '141-01-2052', category: 'Freight' },

  { account: '141-01-3003', category: 'Mainline Lay Price' },
  { account: '141-01-3013', category: 'NDE' },
  { account: '141-01-3013', category: 'Chemical Treatment' },
  { account: '141-01-4006', category: 'Engineering Services' },
  { account: '141-01-4007', category: 'Engineering Services' },

  { account: '141-01-4001', category: 'Inspection Services' },
  { account: '141-01-4002', category: 'Environmental Services' },
  { account: '141-01-4003', category: 'Environmental Services' },
  { account: '141-01-4004', category: 'Environmental Services' },
  { account: '141-01-5001', category: 'Legal Fees Services' },
  { account: '141-01-6002', category: 'Legal Fees Services' },
  { account: '141-01-6009', category: 'Legal Fees Services' },
];

export default accountCategories;
